export const STORAGE_KEYS = {
  THEME: 'cctvplanner_theme_chosen',
  LANGUAGE: 'i18n_language',
  TEXT_SIZE: 'cctv-designer-text-size',
  EDIT_PANEL_OPEN: 'cctv-designer-edit-panel-open',
  PENDING_UPGRADE: 'pendingUpgrade',
  FIRST_CAMERA_PICKER: 'cctv_first_camera_picker_seen_v1',
} as const;
